<div class="modal">
  <div class="modal-content">
    <div class="modal-body">
      <p class="header-text">{{'footer.logout-confirmation'  | translate}}</p>
    </div>
    <div class="modal-footer">
      <button mat-button class="modal-button" (click)="onCancel()" id="cancel-logout">{{'talent-happy-path.buttons.cancel' | translate}}</button>
      <a mat-button href="{{aquentUrl}}" class="modal-button" (click)="logout()" id="confirm-logout">{{'talent-happy-path.buttons.yes' | translate}}</a>
    </div>
  </div>
</div>
